import SoftPropertyHandler from '../../../extra/soft-property-handler';
import hardPropertiesChecker from '../../../extra/hard-properties-checker';

export default {
  saveDerivedProperties,
};

/**
 * Implementation details
 */

function saveDerivedProperties(model, layout, properties, prevProperties) {
  // Can't set new properties on a master item (SUI-1363)

  if (hardPropertiesChecker.canModifyHardProperties(layout)) {
    return model.setProperties(properties);
  }

  const softPropertyHandler = new SoftPropertyHandler(model);
  return softPropertyHandler.saveSoftProperties(prevProperties, properties);
}
